export enum EcheancePrelevementNumber {
  Mensuel = 1,
  Trimestriel = 2,
  Annuel = 3
}
